import { useAppDisplayModeContext } from '@archipro-design/aria';
import type {
    ModuleDataColumn,
    PageBuilderModuleMetaProps,
} from '~/modules/page-builder/types';
import { useStyles } from '@archipro-design/aria';
import { DoubleColumnContainer } from '../../common/pagebuilder.style';
import {
    DUO_COLUMN_VIDEO_WIDTH,
    FULL_COLUMN_WIDTH_MOBILE,
} from '~/modules/page-builder/config/column-constants';
import { ModuleColumnEnum } from 'generated/graphql';
import SingleParagraphModule from '../single-paragraph-module/SingleParagraphModule';
import SingleVideoModule from '../single-video-module/SingleVideoModule';

interface VideoParagraphModuleProps extends PageBuilderModuleMetaProps {
    columns: ModuleDataColumn[];
}

const VideoParagraphModule = ({ columns, meta }: VideoParagraphModuleProps) => {
    const { mobile: isMobile } = useAppDisplayModeContext();
    const videoWidth = isMobile
        ? FULL_COLUMN_WIDTH_MOBILE
        : DUO_COLUMN_VIDEO_WIDTH;

    const { css } = useStyles({ videoWidth });

    return (
        <div className={css(DoubleColumnContainer)}>
            {columns.map((column) => {
                const isVideoColumn =
                    column.type === ModuleColumnEnum.VideoColumn;
                const isTextColumn =
                    column.type === ModuleColumnEnum.TextColumn;

                if (
                    isMobile &&
                    ((!column.video?.videoURL && isVideoColumn) ||
                        (!column.content && isTextColumn))
                ) {
                    return null;
                }

                return (
                    <>
                        {isVideoColumn && (
                            <SingleVideoModule
                                column={column}
                                playIconSizeDesktop={98}
                            />
                        )}
                        {isTextColumn && (
                            <SingleParagraphModule
                                column={column}
                                meta={meta}
                            />
                        )}
                    </>
                );
            })}
        </div>
    );
};

export default VideoParagraphModule;
